import { Injectable } from '@angular/core';
import { DilysuService } from './dilysu.service';
import { combineLatest, filter, map, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TocynService {

  constructor(private dilysuService: DilysuService) { }

  nolTocynMynediadDilys(): Observable<string | null> {

    return combineLatest([
      // Gwirio statws silent refresh
      this.dilysuService.adnewyddu$.pipe(
        filter(adnewyddu => !adnewyddu),
        take(1)
      ),
      // Gwirio defnyddiwr wedi llwytho
      this.dilysuService.defnyddiwrWediLlwytho$.pipe(
        filter(wediLlwytho => wediLlwytho),
        take(1)
      )
    ]).pipe(
      // Os uchod wedi pasio, nol defnyddiwr a wedyn y tocyn
      map(() => {
        const user = this.dilysuService.nolDefnyddiwr();

        if (!user || user.expired || !user.access_token) {
          console.warn('Methu nol tocyn dilys, felly yn allgofnodi.');

          // Os methu cael tocyn, allgofnodi
          this.dilysuService.allgofnodi();

          return null;
        }

        return this.dilysuService.nolTocynMynediad();
      })
    );
  }
}
